'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

// styled


var _mobxReact = require('mobx-react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Fieldset = require('../Fieldset');

var _Fieldset2 = _interopRequireDefault(_Fieldset);

var _formula = require('./formula');

var _wrapper = require('../Fieldset/styled/wrapper');

var _wrapper2 = _interopRequireDefault(_wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Converse = (_dec = (0, _mobxReact.inject)('formStore'), _dec(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Converse, _Component);

  function Converse() {
    (0, _classCallCheck3.default)(this, Converse);
    return (0, _possibleConstructorReturn3.default)(this, (Converse.__proto__ || (0, _getPrototypeOf2.default)(Converse)).apply(this, arguments));
  }

  (0, _createClass3.default)(Converse, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_Fieldset2.default, (0, _extends3.default)({}, this.props, {
        onBlur: this.props.onBlur,
        onChange: this.props.onChange,
        childrenAdjacent: true
      }));
    }
  }], [{
    key: 'getTokens',
    value: function getTokens(formStore, field) {
      if (field.visible) {
        var amount = Converse.calculateFormula(formStore.values, field.element['#payment_amount']) || 0;
        var formattedAmount = parseFloat(amount).toFixed(2);
        return {
          payment_amount: formattedAmount,
          payment_amount_number: formattedAmount.slice(0, -3),
          payment_amount_decimals: formattedAmount.slice(-2)
        };
      }
      return {};
    }

    /**
     * financial_amount_monthly_suggestion|0| + financial_amount_monthly|0| + financial_amount_yearly_suggestion|0| + financial_amount_yearly|0|
     * @param values
     * @param formula
     * @returns {*}
     */

  }, {
    key: 'calculateFormula',
    value: function calculateFormula(values, formula) {
      var amount = (0, _formula.parse)(formula, values);
      if (isNaN(amount)) {
        return null;
      }
      return amount < 0 ? 0 : amount;
    }
  }]);
  return Converse;
}(_react.Component), _class2.meta = {
  wrapper: _wrapper2.default,
  label: _Fieldset2.default.meta.label,
  wrapperProps: _Fieldset2.default.meta.wrapperProps,
  labelVisibility: _Fieldset2.default.meta.labelVisibility,
  hasValue: false
}, _class2.propTypes = {
  onBlur: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func.isRequired
}, _temp)) || _class) || _class);
exports.default = Converse;